<template>
	<div class="exposition-right-main">
		<div class="exposition-right-main-left">
			<div class="exposition-left-main-cell">
				<chonghuandianxinxi></chonghuandianxinxi>
			</div>
			<div class="exposition-left-main-cell">
				<chonghuandiandingdan></chonghuandiandingdan>
			</div>
			<div class="exposition-left-main-cell">
				<zhandianfuhelv></zhandianfuhelv>
			</div>
			<div class="exposition-left-main-cell">
				<zongdianliangjidianjia></zongdianliangjidianjia>
			</div>
		</div>
		<div class="exposition-right-main-right">
			<div class="duonenghubu">
				<duonenghubu></duonenghubu>
			</div>
			<div class="exposition-left-main-cell">
				<diangangfuhe></diangangfuhe>
			</div>
			<div class="exposition-left-main-cell">
				<leijishouyi></leijishouyi>
			</div>
		</div>
	</div>
</template>

<script>
	import chonghuandianxinxi from '@/views/components/exposition/chonghuandianxinxi.vue'
	import chonghuandiandingdan from '@/views/components/exposition/chonghuandiandingdan.vue'
	import zongdianliangjidianjia from '@/views/components/exposition/zongdianliangjidianjia.vue'
	import zhandianfuhelv from '@/views/components/exposition/zhandianfuhelv.vue'
	import duonenghubu from '@/views/components/exposition/duonenghubu.vue'
	import diangangfuhe from '@/views/components/exposition/diangangfuhe.vue'
	import leijishouyi from '@/views/components/exposition/leijishouyi.vue'
	export default{
		components: {
			chonghuandianxinxi,
			chonghuandiandingdan,
			zongdianliangjidianjia,
			zhandianfuhelv,
			duonenghubu,
			diangangfuhe,
			leijishouyi
		}
	}
</script>

<style lang="scss" scope>
	.exposition-right-main {
		width: 970px;
		display: flex;
		flex-wrap: wrap;
		margin-top: 70px;
		justify-content: space-between;
		.exposition-right-main-left{
			width: 460px;
			margin-right: 20px;
			z-index: 1000;
		}
		.exposition-right-main-right{
			width: 460px;
			.duonenghubu{
				height: 548px;
				margin-bottom: 180px;
			}
		}
		.exposition-left-main-cell{
			height: 362px;
			margin-bottom: 3px;
		}
	}
	
</style>